import type { ComponentPropsWithRef } from 'react'
import * as Dialog from '@radix-ui/react-dialog'
import cn from 'classnames'
import styles from './Sheet.module.css'

/**
 * This is the Sheet component used for the mobile version of the navigation menu.
 */

function Content({ ref, className, ...props }: ComponentPropsWithRef<typeof Dialog.Content>) {
  return <Dialog.Content ref={ref} className={cn(styles.content, className)} {...props} />
}
Content.displayName = 'Sheet.Content'

function Overlay({ ref, className, ...props }: ComponentPropsWithRef<typeof Dialog.Overlay>) {
  return <Dialog.Overlay ref={ref} className={cn(styles.overlay, className)} {...props} />
}
Overlay.displayName = 'Sheet.Overlay'

function Trigger({ ref, className, ...props }: ComponentPropsWithRef<typeof Dialog.Trigger>) {
  return <Dialog.Trigger ref={ref} className={cn(styles.trigger, className)} {...props} />
}
Trigger.displayName = 'Sheet.Trigger'

function Title({ ref, className, ...props }: ComponentPropsWithRef<typeof Dialog.Title>) {
  return <Dialog.Title ref={ref} className={cn(styles.title, className)} {...props} />
}
Title.displayName = 'Sheet.Title'

export const Sheet = {
  Content,
  Overlay,
  Trigger,
  Title,
  Root: Dialog.Root,
  Close: Dialog.Close,
  Portal: Dialog.Portal,
}
